export default __webpack_public_path__ + "static/list-block-1-bg-tablet-be4648a5fefee73055e2769641c71ef2.png";